import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import {IdexService} from 'app/idex.service';
import {LoadingButtonComponent} from 'app/shared/loading-button/button';
import {Toast} from 'app/shared/toast/toast';

@Component({
   selector: 'app-twofactor',
   templateUrl: './twofactor.component.html',
   styleUrls: ['./twofactor.component.css']
})
export class TwofactorComponent implements OnInit {
   @ViewChild('code', {static: true}) input: ElementRef;
   @ViewChild('button') button: LoadingButtonComponent;

   divShowQr: any;
   verificationGoogle: any;
   errorMessage: string;
   signatureId: string;
   qrCodeUrl: string;
   message: string;
   type: string;
   pattern: string;

   constructor(private dialogRef: MatDialogRef<TwofactorComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any,
               private service: IdexService,
               public toast: Toast) {
   }

   ngOnInit() {
      this.divShowQr = false;
      this.message = 'twofactor.instruction';
      this.type = 'text';
      this.pattern = '^(\\d{6})$';
      this.input.nativeElement.focus();
      switch (this.data.mode) {
         case 'login':
            this.message = this.data.message;
            if (this.message.includes('Authenticator')) {
               this.divShowQr = true;
            } else {
               this.divShowQr = false;
            }
            break;
         case 'update':
            this.message = 'twofactor.instruction2';
            this.service.getTwoFactorQr()
               .subscribe((data: any) => {
                  this.qrCodeUrl = data.qrCodeUrl;
               }, error => {
                  this.errorMessage = error;
               });
            break;
         case 'sign':
            this.qrCodeUrl = null;
            this.message = '';
            const isTwoFactorSignGoogle = this.data.isTwoFactorSignGoogle;
            if (isTwoFactorSignGoogle) {
               this.message = 'twofactor.instruction3';
            } else {
               this.type = 'password';
               this.pattern = '^.+$';
               this.message = 'twofactor.instruction_password';
            }
            break;
      }
   }

   onSubmit() {
      this.errorMessage = null;
      if (this.data.key == null) {
         if (this.data.mode === 'sign') {
            let code = btoa(encodeURIComponent(this.input.nativeElement.value));
            let taskForm: any;
            if (this.data.body.taskForm !== null) {
               taskForm = this.data.body.taskForm;
            } else {
               taskForm = null;
            }
            this.service.signDocument(this.data.body.taskId, this.data.body.data, this.data.body.password, code, taskForm)
               .subscribe(response => {
                  this.dialogRef.close(response);
               }, error => {
                  this.toast.dismiss();
                  this.button.reset();
                  this.errorMessage = <any>error;
               })
         } else {
            this.service.twoFactorVerification(this.input.nativeElement.value)
               .subscribe(
                  data => {
                     this.dialogRef.close(data.code);
                  },
                  error => {
                     this.toast.dismiss();
                     this.button.reset();
                     this.errorMessage = <any>error;
                  }
               );
         }
      } else {
         this.service.twoFactorLogin(this.input.nativeElement.value, this.data.key)
            .subscribe(
               data => {
                  this.dialogRef.close(data);
               },
               error => {
                  this.toast.dismiss();
                  this.button.reset();
                  this.errorMessage = <any>error;
               }
            );
      }
   }

   sendQr() {
      this.service.sendTwoFactorQr(this.data.key)
         .subscribe((data: any) => {
            this.toast.success(data);
         }, error => {
            this.toast.error(error);
         });
   }

   validate() {
      this.button.disabled = !this.input.nativeElement.checkValidity();
   }
}
